import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {
    TableRow,
    TableRowColumn,
} from 'material-ui/Table';
import {convertDate} from '../shared/functions';
import FuseTheme from '../global/theme';
import Toggle from 'material-ui/Toggle';
import IconButton from 'material-ui/IconButton';
import ContentAdd from 'material-ui/svg-icons/content/add-circle';
import ContentRemove from 'material-ui/svg-icons/content/remove-circle';

/**
 * A component for creating a Repack or Retail Box row with addition to or deletion from Transfer lists.
 * Loaded by NewTransferCollectionTable.
 *
 */
class NewTransferCollectionTableRow extends Component {
    constructor(props) {
        super(props);
        this.state = {
            collection: [],
            showContents: false,
        };

        this.handleAddClick = this.handleAddClick.bind(this);
        this.handleDeleteClick = this.handleDeleteClick.bind(this);
    }

    // Handle event to display/hide Collection contents
    handleToggleClick = (e, toggle) => {
        this.setState({
            showContents: toggle,
        });
    };

    // Pass event to add this item
    handleAddClick() {
        this.props.onAddClick(this.props.data);
    }

    // Pass event to remove this item
    handleDeleteClick() {
        this.props.onDeleteClick(this.props.data);
    }

    // Assemble display for Products
    setProductNames = (collection) => {
        let productNames = [];
        for (let i = 0; i < collection.length; i++) {
            const item = collection[i];
            // Display: Barcode - Product Name - Quantity (Unit Type)
            productNames.push(item.barcode + ' - ' + item.product_name + ' - ' + item.qty + ' (' + item.unit_type + ')');
        }
        return productNames;
    };

    // Create Collection contents
    makeContentsTable = () => {
        const styles = {
            contents: {
                height: 0,
                maxHeight: 0,
                overflow: 'hidden',
            },
            contentsOpen: {
                maxHeight: '106px',
                fontSize: '14px',
                color: FuseTheme.palette.lightTextColor,
                padding: '0.5em 1em 0.5em 45px',
                verticalAlign: 'top',
                overflowY: 'auto',
                boxSizing: 'border-box',
            },
        };
        const list = this.props.data.contents;
        if (!list || list.length === 0 || !list.length) {
            return (
                <div style={styles.itemContainer}>No Products in this Collection</div>
            )
        }
        let productNames = this.setProductNames(list);
        return (
            productNames.map((item, index) => (
                <div
                    key={list[index].barcode + '-' + index}
                    style={(this.state.showContents) ? styles.contentsOpen : styles.contents}
                >
                    {productNames[index]}
                </div>
            ))
        )
    };

    render() {
        const resultStyles = {
            contentRow: {height: 'auto'},
            icon: {height: 36, padding: 8, overflow: 'inherit'},
            iconRow: {width: 50, maxWidth: 50, paddingLeft: 14, paddingRight: 16},
            row: {height: 36, borderBottom: 'none'},
        };
        const itemStyles = {
            contentRow: {height: 'auto'},
            icon: {height: 40, padding: 8, overflow: 'inherit'},
            iconRow: {width: 50, maxWidth: 50, paddingLeft: 14, paddingRight: 16},
            row: {height: 40, borderBottom: 'none'},
        };
        const styles = (this.props.tableType === 'items') ? itemStyles : resultStyles;

        // Results: Barcode / Created / View Contents / Add
        // Selected Items: Barcode / Qty / View Contents / Remove

        return (
            [
                <TableRow key={'row-columns-' + this.props.data.barcode} style={styles.row}>
                    <TableRowColumn className={'row-item-' + this.props.data.barcode} style={styles.row}>
                        <span>{this.props.data.barcode}</span>
                    </TableRowColumn>

                    {this.props.tableType === 'results' &&
                    <TableRowColumn className={'row-created-' + this.props.data.barcode} style={styles.row}>
                        <span>{convertDate(this.props.data.modified)}</span>
                    </TableRowColumn>
                    }

                    {this.props.tableType === 'items' &&
                    <TableRowColumn className={'row-qty-' + this.props.data.barcode} style={styles.row}>
                        <span>{this.props.data.qty}</span>
                    </TableRowColumn>
                    }

                    <TableRowColumn style={styles.row}>
                        {this.props.data.contents && this.props.data.contents.length > 0 &&
                        <Toggle
                            label="View Contents"
                            labelPosition="right"
                            onToggle={this.handleToggleClick}
                        />
                        }
                    </TableRowColumn>

                    {this.props.tableType === 'results' &&
                    <TableRowColumn style={{...styles.row, ...styles.iconRow}}>
                        <IconButton style={styles.icon} onClick={(e) => this.handleAddClick(e)}>
                            <ContentAdd color={FuseTheme.palette.primary1Color}/>
                        </IconButton>
                    </TableRowColumn>
                    }

                    {this.props.tableType === 'items' &&
                    <TableRowColumn style={{...styles.row, ...styles.iconRow}}>
                        <IconButton style={styles.icon} onClick={(e) => this.handleDeleteClick(e)}>
                            <ContentRemove color={FuseTheme.palette.primary1Color}/>
                        </IconButton>
                    </TableRowColumn>
                    }
                </TableRow>,
                <TableRow key={'row-contents-' + this.props.data.barcode} style={styles.contentRow}>
                    <TableRowColumn colSpan={4} style={styles.contentRow}>
                        {[...this.makeContentsTable()]}
                    </TableRowColumn>
                </TableRow>
            ]

        )
    }
}

NewTransferCollectionTableRow.propTypes = {
    addField: PropTypes.bool,
    data: PropTypes.object.isRequired,
    onAddClick: PropTypes.func,
    onDeleteClick: PropTypes.func,
    tableType: PropTypes.string.isRequired
};

NewTransferCollectionTableRow.defaultProps = {
    addField: true,
    style: {padding: 0},
    tableType: 'items'
};

export default NewTransferCollectionTableRow;


// WEBPACK FOOTER //
// ./src/Fuse/components/NewTransferCollectionTableRow.js